<template>
  <v-card :color="ant" flat>
    <v-card-text>
      <span class="text-h6">Your Feedback</span>
      <div v-if="orderDetail.rating">
        <v-list-item>
        <v-list-item-content class="">
          <v-list-item-title
            >
            <span class="text-caption font-weight-light">
              {{ formatDateMonth(orderDetail.rating.created_at) }}</span
            >
          </v-list-item-title>
        </v-list-item-content>

        <span> {{ orderDetail.rating.rating }}</span>
        <v-list-item-action class="ml-n1">
          <v-rating
            v-model="orderDetail.rating.rating"
            half-increments
            background-color="orange lighten-3"
            color="orange"
            class=""
            readonly
            size="20"
          ></v-rating>
        </v-list-item-action>
      </v-list-item>
    
      <div class="mt-3">
        <span style="white-space: pre-line" class="ml-4" v-html="orderDetail.rating.review"> </span>
      </div>
      </div>
      <div class="mt-4" v-else>
        No review yet kinldy rate this writer
        <v-btn color="info" class="float-right mt-n4" @click="ratingShow = true"> Rate writer</v-btn>
      </div>
    </v-card-text>
    <Rating :show='ratingShow' :orderDetail="orderDetail" @close="ratingShow=false" />
  </v-card>
</template>

<script>
import colorMxn from "@/mixins/colorMxn";
import timeZoneMxn from '@/mixins/timezone_mixin';

export default {
  name: "reviewComponent",
  components: {
    Rating: () => import('@/modules/Rating'),
  },
  mixins: [colorMxn, timeZoneMxn],
  props: ["orderDetail"],
  data() {
    return {
      ratingShow: false,
    };
  }
};
</script>
